export const IMPORTED_EVENT_SHARE_COPIED_TOAST_TITLE = 'Link Copied';

export const IMPORTED_EVENT_SHARE_COPIED_TOAST_MESSAGE = 'The link to this page has been copied to your clipboard.';

export const IMPORTED_EVENT_SHARE_FAILED_TOAST_TITLE = 'Could Not Copy Link';

// Deliberately does not quote the URL back. A URL is one unbreakable token, so `word-break: normal`
// in Toast pushes the body past the 312px react-toastify slot, which clips it with overflow-x hidden
// and truncates the address it was meant to hand over.
export const IMPORTED_EVENT_SHARE_FAILED_TOAST_MESSAGE = 'Copy the page address from your browser to share this page.';
